import script from "./ShopTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopTable.vue?vue&type=script&lang=ts&setup=true"

import "./ShopTable.vue?vue&type=style&index=0&id=d95abd98&lang=scss&scoped=true"
import "./ShopTable.vue?vue&type=style&index=1&id=d95abd98&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d95abd98"]])

export default __exports__